// Centralized mock data for Spending Controls feature

export const mockControls = {
  deliveryTargets: [
    {
      target: '123-456-7890',
      type: 'sms',
      isPrimary: true,
    },
    {
      target: 'test@domain.com',
      type: 'email',
      isPrimary: false,
    },
  ],
  controls: [
    {
      displayName: 'Merchant Types',
      id: 'C04',
      enabled: true,
      category: 'merchantTypes',
      options: [
        { displayName: 'Department Store', description: 'Clothing, home goods, general retail', id: 'C04T00' },
        { displayName: 'Entertainment', description: 'Movies, music, streaming', id: 'C04T01' },
        { displayName: 'Gas Station', description: 'Fuel and convenience stores', id: 'C04T02' },
        { displayName: 'Restaurant', description: 'Dining and food delivery', id: 'C04T06' },
        { displayName: 'Household', description: 'Home supplies and maintenance', id: 'C04T04' },
        { displayName: 'Personal Care', description: 'Beauty, health, and wellness', id: 'C04T05' },
        { displayName: 'Grocery', description: 'Supermarkets and food stores', id: 'C04T03' },
        { displayName: 'Travel', description: 'Airlines, hotels, transportation', id: 'C04T07' },
        { displayName: 'Age Restricted', description: 'Alcohol, tobacco, adult content', id: 'C04T08' },
        { displayName: 'Other Merchant', description: 'Miscellaneous and uncategorized', id: 'C04T09' },
      ],
      valueType: 'arrayOfStrings',
      value: [],
    },
    {
      displayName: 'Spend Limits - Per Card',
      description: '',
      id: 'C014',
      enabled: true,
      category: 'spendingLimits',
      valueType: 'integer',
      value: 50,
    },
    {
      displayName: 'Spend Limits - Per Transaction',
      description: '',
      id: 'C06',
      enabled: true,
      category: 'spendingLimits',
      valueType: 'integer',
      value: 50,
    },
    {
      displayName: 'International',
      description: '',
      id: 'C07',
      enabled: true,
      category: 'general',
      valueType: 'boolean',
      value: false,
    },
    {
      displayName: 'Card On/Off',
      description: '',
      id: 'C01',
      enabled: true,
      category: 'general',
      valueType: 'boolean',
      value: true,
    },
    {
      displayName: 'Transaction Types',
      id: 'C03',
      enabled: true,
      category: 'transactionTypes',
      options: [
        { displayName: 'In Store Transaction', description: 'Department stores, pharmacies, and other card purchases signed for by the cardholder.', id: 'C03T00' },
        { displayName: 'eCommerce', description: 'Online bill payment, online shopping and other card purchases paid for via Internet.', id: 'C03T01' },
        { displayName: 'Mail/Phone Order', description: 'Catalog shopping, travel agents payments and other card purchases paid for via telephone, fax, mail, or Internet.', id: 'C03T02' },
        { displayName: 'Recurring', description: 'Automated bill payment, monthly subscriptions, and other card purchases for which payment is scheduled on a predetermined date.', id: 'C03T04' },
        { displayName: 'ATM', description: 'Cash dispensers, cash kiosks, and ATMs from which cardholders can withdraw cash.', id: 'C03T05' },
        { displayName: 'Other', description: 'Other cases where transaction types cannot be identified are under this type.', id: 'C03T07' },
      ],
      valueType: 'arrayOfStrings',
    },
    {
      displayName: 'Cash Advance',
      description: '',
      id: 'C015',
      enabled: true,
      category: 'spendingLimits',
      valueType: 'monetary',
      value: 500.00,
    },
    {
      displayName: 'Spend Limits - Per Month',
      description: '',
      id: 'C09',
      enabled: true,
      category: 'spendingLimits',
      valueType: 'integer',
      value: 500,
    },
    {
      displayName: 'Self Imposed Credit Limit',
      description: '',
      id: 'C013',
      enabled: true,
      category: 'spendingLimits',
      valueType: 'integer',
      value: 500,
    },
    {
      displayName: 'Daily Transaction Limit',
      description: 'Maximum transactions per day',
      id: 'VC01',
      enabled: true,
      category: 'velocityControls',
      valueType: 'integer',
      value: 4,
      min: 1,
      max: 10,
      mid: 5,
      unit: 'per day',
      icon: 'schedule',
    },
    {
      displayName: 'Weekly Transaction Limit',
      description: 'Maximum transactions weekly',
      id: 'VC02',
      enabled: true,
      category: 'velocityControls',
      valueType: 'integer',
      value: 22,
      min: 1,
      max: 50,
      mid: 25,
      unit: 'weekly',
      icon: 'schedule',
    },
    {
      displayName: 'Monthly Transaction Limit',
      description: 'Maximum transactions monthly',
      id: 'VC03',
      enabled: true,
      category: 'velocityControls',
      valueType: 'integer',
      value: 40,
      min: 1,
      max: 100,
      mid: 50,
      unit: 'monthly',
      icon: 'schedule',
    },
  ],
  alerts: [
    {
      displayName: 'Merchant Types',
      id: 'A04',
      enabled: true,
      category: 'alerts',
      options: [
        { displayName: 'Personal Care', description: 'Drug stores, pharmacies, health professional services, medical services and labs, ambulance services, legal services, and attorneys.', id: 'A04T05' },
        { displayName: 'Restaurant', description: 'Diners, fast-food restaurants, and caterers.', id: 'A04T06' },
        { displayName: 'Travel', description: 'Airlines, cars and automotive rentals, hotels, motels, inns, resorts, toll and bridge fees, taxicabs and limousines, timeshares, parking lots, and garages.', id: 'A04T07' },
        { displayName: 'Age Restricted', description: 'Liquor & cigar stores, casinos, betting, bars, taverns, nightclubs, dating and escort services, lottery, and gambling.', id: 'A04T08' },
        { displayName: 'Other', description: 'Other cases where merchant types cannot be identified are under this type.', id: 'A04T09' },
        { displayName: 'Department Store', description: 'Clothing & accessories, office supplies, florists, automobile dealers, home improvement services and equipment, art and sports supplies, and direct marketing.', id: 'A04T00' },
        { displayName: 'Entertainment', description: 'Amusement parks, movie theatres, books, music, games, digital entertainment, sports arenas including golf courses, athletic events, aquariums, video rentals, and dance halls.', id: 'A04T01' },
        { displayName: 'Gas Station', description: 'Fuel dispenser, warehouse club gas, and petroleum and petroleum products.', id: 'A04T02' },
        { displayName: 'Grocery', description: 'Supermarkets, bakeries, meat freezers, candy and other confectionaries, dairy products, speciality markets, and convenience stores.', id: 'A04T03' },
        { displayName: 'Household', description: 'Utility services, contracted services, business services, courier services, home improvement services, household appliance stores, money send and stored value cards, and saving bonds.', id: 'A04T04' },
      ],
      valueType: 'arrayOfStrings',
      value: ['A04T06', 'A04T03'],
    },
    {
      displayName: 'Spend Limits - Per Card',
      description: '',
      id: 'A014',
      enabled: true,
      category: 'alerts',
      valueType: 'integer',
      value: 50,
    },
    {
      displayName: 'Spend Limits - Per Transaction',
      description: '',
      id: 'A06',
      enabled: true,
      category: 'alerts',
      valueType: 'integer',
      value: 50,
    },
    {
      displayName: 'International',
      description: '',
      id: 'A07',
      enabled: true,
      category: 'alerts',
      valueType: 'boolean',
      value: false,
    },
    {
      displayName: 'Transaction Types',
      id: 'A03',
      enabled: true,
      category: 'alerts',
      options: [
        { displayName: 'Other', description: 'Other cases where transaction types cannot be identified are under this type.', id: 'A03T07' },
        { displayName: 'In Store', description: 'Department stores, pharmacies, and other card purchases signed for by the cardholder.', id: 'A03T00' },
        { displayName: 'eCommerce', description: 'Online bill payment, online shopping and other card purchases paid for via Internet.', id: 'A03T01' },
        { displayName: 'Mail/Phone Order', description: 'Catalog shopping, travel agents payments and other card purchases paid for via telephone, fax, mail, or Internet.', id: 'A03T02' },
        { displayName: 'Auto Pay/Recurring', description: 'Automated bill payment, monthly subscriptions, and other card purchases for which payment is scheduled on a predetermined date.', id: 'A03T04' },
        { displayName: 'ATM', description: 'Cash dispensers, cash kiosks, and ATMs from which cardholders can withdraw cash.', id: 'A03T05' },
      ],
      valueType: 'arrayOfStrings',
      value: ['A03T00', 'A03T02', 'A03T05'],
    },
    {
      displayName: 'Cash Advance',
      description: '',
      id: 'A015',
      enabled: true,
      category: 'alerts',
      valueType: 'monetary',
      value: 500.00,
    },
    {
      displayName: 'Spend Limits - Per Month',
      description: '',
      id: 'A09',
      enabled: true,
      category: 'alerts',
      valueType: 'integer',
      value: 500,
    },
    {
      displayName: 'Self Imposed Credit Limit',
      description: '',
      id: 'A013',
      enabled: true,
      category: 'alerts',
      valueType: 'integer',
      value: 500,
    },
    {
      displayName: 'All Transactions',
      description: 'Alert on every transaction',
      id: 'A030',
      enabled: true,
      category: 'alerts',
      valueType: 'boolean',
      value: true,
    },
    {
      displayName: 'None',
      description: 'Disable alerts',
      id: 'A029',
      enabled: true,
      category: 'alerts',
      valueType: 'boolean',
      value: true,
    },
  ],
};

export const mockCardDetails = {
  cardholder: 'Alex Johnson',
  cardNumber: '1234567812344829',
  expiry: '12/28',
  cvv: '123',
};

export const mockSpendingControlsSymXchange = {
  deliveryTargets: [],
  controls: [
    {
      displayName: 'Point-of-sale Daily Limit',
      description: 'The maximum amount that can be withdrawn for online, point-of-sale (PIN-based merchant) transactions each day',
      id: 'PosLimit',
      enabled: true,
      category: 'spendingLimits',
      valueType: 'monetary',
      value: 100.0,
    },
    {
      displayName: 'Point-of-sale Daily Limit Count',
      description: 'The maximum number of point-of-sale (PIN-based merchant) transactions per day that your credit union allows.',
      id: 'PosCountLimit',
      enabled: true,
      category: 'velocityControls',
      valueType: 'integer',
      value: 5,
    },
  ],
  alerts: [],
};
